module.exports = __webpack_public_path__ + "img/apay-icon-black.60cc2183.svg";